import Pipeline from "../Pipeline";
import { ICompose } from "../types";
import { CacheItem } from "./cache";

export default class CacheCompose extends Pipeline<Array<CacheItem>> {
    private compose: ICompose;

    constructor(compose: ICompose) {
        super();

        this.compose = compose;
    }

    process(cps: Array<CacheItem>): void {
        cps.forEach((cp: CacheItem) => {
            this.compose.push(cp);
        });
    }
}
